import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoliciesService } from 'src/app/api/services/policies.service';
import { AppResource } from 'src/app/app.resource';
import { PolicyState } from 'src/app/core/enums/policy-state.enum';
import { PolicyVersionState } from 'src/app/core/enums/policy-version-state.enum';
import { Resource } from 'src/app/resources/resource';
import {
  ELECTRONIC_SIGNATURE_PATH_AMENDMENT,
  ERROR_404_PATH
} from 'src/app/shared/constants/route.constants';
import { HeaderVM } from 'src/app/shared/models/components/headerVm';

@Component({
  selector: 'app-e-sign-msg-endorsement',
  templateUrl: './e-sign-msg-endorsement.component.html'
})
export class ESignMsgEndorsementComponent implements OnInit {
  status: number = 0;
  policyStatus: number = 0;
  message?: string = '';
  title: string = '';
  public resource!: Resource;
  headerStep: HeaderVM = new HeaderVM('Signature', 3, 'Documents contractuels', 9);
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private resources: AppResource,
    private policyService: PoliciesService
  ) {
    this.resource = resources['resource'];
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const policyVersionStatus = params.get('policyVersionStatus');
      const policyStatus = params.get('policyStatus');
      this.policyStatus = policyStatus ? parseInt(policyStatus, 10) : 0;
      if (policyVersionStatus) {
        this.handleStatus(parseInt(policyVersionStatus, 10));
      }
    });
  }

  private handleStatus(status: number): void {
    if (isNaN(status)) {
      this.router.navigate([ERROR_404_PATH]);
    } else if (status === PolicyState.Wait4Sign) {
      this.router.navigate([ELECTRONIC_SIGNATURE_PATH_AMENDMENT]);
    } else {
      this.status = status;
      this.setMessage();
    }
  }

  private setMessage(): void {
    const combinedStatus = `${this.status}_${this.policyStatus}`;

    switch (combinedStatus) {
      case `${PolicyVersionState.Ongoing}_${PolicyState.Signed}`:
        this.setMessageContent(
          this.resource.signature['signature_msg_title'],
          this.resource.signature['signed_message']
        );
        break;
      case `${PolicyVersionState.Ongoing}_${PolicyState.Ongoing}` ||
        `${PolicyVersionState.Ongoing}_${PolicyState.Unpaid}`:
        this.setMessageContent(
          this.resource.signature['signature_msg_title'],
          this.resource.signature['ongoing_message']
        );
        break;
      case `${PolicyVersionState.Ongoing}_${PolicyState.Temporary}`:
        this.setMessageContent(
          this.resource.signature['signature_msg_title'],
          this.resource.signature['auto_term_message']
        );
        break;
      case `${PolicyVersionState.Ongoing}_${PolicyState.Suspended}`:
        this.setMessageContent(
          this.resource.signature['signature_msg_title'],
          this.resource.signature['suspended_message']
        );
        break;
      case `${PolicyVersionState.Na}_${PolicyState.Na}` ||
        `${PolicyVersionState.Na}_${PolicyState.Terminated}` ||
        `${PolicyVersionState.Na}_${PolicyState.Cancelled}` ||
        `${PolicyVersionState.Replaced}_${PolicyState.Na}` ||
        `${PolicyVersionState.Replaced}_${PolicyState.Terminated}` ||
        `${PolicyVersionState.Replaced}_${PolicyState.Cancelled}` ||
        `${PolicyVersionState.Na}_${PolicyState.Signed}`:
        this.setMessageContent(this.resource.signature['inactive_title']);
        break;
      default:
        this.setMessageContent(this.resource.signature['inactive_title_endorsement']);
        break;
    }
  }

  private setMessageContent(title: string, message?: string): void {
    this.title = title;
    this.message = message;
  }
}
